module.exports = __webpack_public_path__ + "img/aussie-rules.b5031a72.svg";